import React from 'react';

import styled from '@emotion/styled';

import MoreInfoIcon from '../../../components/Icons/MoreInfoIcon';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import ViewDetails from '../../../components/Table/TableAccessories/ViewDetails';
import DemoRequestData from '../../../components/Table/TableSliderViews/DemoRequestData';
import Export from './Export';

const DemoRequests = () => {
  return (
    <Page title='Logirate | Demo Requests'>
      <PageLayout noTitle={true}>
        <Container>
          <Table
            // border
            tableTitle='DEMO REQUEST LIST'
            tableFilterBoxFeatures={{
              rightAttr: [
                {
                  type: 'regular',
                  comp: <Export />,
                },
              ],
            }}
            tableHeader={{
              Timestamp: 'createdAt',
              'Company Name': 'companyName',
              'First Name': 'firstName',
              'Last Name': 'lastName',
              'Phone Number': 'phoneNumber',
              'Business Email': 'businessEmail',
            }}
            tableDataSourceUrl='ba/v1/demo-requests'
            cellsCustomComp={{
              createdAt: <TableDateFormatter dataKey='createdAt' />,
            }}
            moreOptionsComponents={[
              <ViewDetails
                key='View information'
                label='View information'
                width='232px'
                icon={<MoreInfoIcon />}
                sliderCompFn={(data: any) => <DemoRequestData data={data} />}
              />,
            ]}
          />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DemoRequests;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
